<div class="ds-dashboard-block ds-dashboard-dashboard-box">
  <div class="ds-dashboard-block-header">
    <div class="ds-dashboard-category-icon">
      <ion-icon name="checkmark-outline"></ion-icon>
    </div>
    <div class="ds-dashboard-block-header-title">{{ 'PLAN_UPGRADED' | translate }}</div>
  </div>

  <div class="ds-dashboard-block-content">
    <div class="ds-text">
      You have successfully upgraded your plan, you can now enter your Totalum and enjoy the capacity of your new plan. If you have any questions, send us an email at <a href="mailto:contacto&#64;totalum.app">contacto&#64;totalum.app</a> and we will respond quickly.
    </div>

  </div>
</div>